export const CurrencySymbols = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  CNY: "¥",
  RUB: "₽",
  UAH: "₴",
  INR: "₹",
  KRW: "₩",
  AUD: "A$",
  CAD: "C$",
  CHF: "CHF",
  SEK: "kr",
  NOK: "kr",
  DKK: "kr",
  PLN: "zł",
  BRL: "R$",
  MXN: "MX$",
  ZAR: "R",
  HKD: "HK$",
  SGD: "S$",
  NZD: "NZ$",
} as const;

export type CurrencyCodeType = keyof typeof CurrencySymbols;

export enum CurrencyCodeEnum {
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
  JPY = "JPY",
  CNY = "CNY",
  RUB = "RUB",
  UAH = "UAH",
  INR = "INR",
  KRW = "KRW",
  AUD = "AUD",
  CAD = "CAD",
  CHF = "CHF",
  SEK = "SEK",
  NOK = "NOK",
  DKK = "DKK",
  PLN = "PLN",
  BRL = "BRL",
  MXN = "MXN",
  ZAR = "ZAR",
  HKD = "HKD",
  SGD = "SGD",
  NZD = "NZD",
  CZK = "CZK",
  TRY = "TRY",
}
export const formatCurrencyWithSymbol = (
  num = 0,
  currency = "USD",
  language: string,
  round = false,
  hasSign = true,
) => {
  const value = Math.abs(num)
    .toLocaleString(language, {
      style: "currency",
      currency: currency,
      currencyDisplay: "code",
      maximumFractionDigits: round ? 0 : 2,
    })
    .replace(currency, "")
    .trim();

  const { symbol = currency, position = "before" } =
    CurrencyDisplayConfig[currency as CurrencyCodeType] || {};
  const displayValue =
    position === "before" ? `${symbol}${value}` : `${value}${symbol}`;

  return num < 0
    ? `${hasSign ? "-" : ""}${displayValue}`
    : `${hasSign ? "+" : ""}${displayValue}`;
};

export type ICurrencySymbolsDisplay = Record<
  string,
  {
    code: keyof typeof CurrencySymbolsPortal;
    symbol: string;
    position?: "before" | "after"; // Optional, default is "before"
  }
>;

export const CurrencySymbolsPortal = {
  USD: "US$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  CNY: "¥",
  RUB: "₽",
  UAH: "₴",
  INR: "₹",
  KRW: "₩",
  AUD: "A$",
  CAD: "Can$",
  CHF: "CHF",
  SEK: "kr",
  NOK: "kr",
  DKK: "kr",
  PLN: "zł",
  BRL: "R$",
  MXN: "Mex$",
  ZAR: "R",
  HKD: "HK$",
  SGD: "S$",
  NZD: "NZ$",
  CZK: "Kč",
  TRY: "₺",
} as const;

export const CurrencyDisplayConfig: ICurrencySymbolsDisplay = {
  [CurrencyCodeEnum.AUD]: {
    code: CurrencyCodeEnum.AUD,
    symbol: CurrencySymbolsPortal.AUD,
  },
  [CurrencyCodeEnum.EUR]: {
    code: CurrencyCodeEnum.EUR,
    symbol: CurrencySymbolsPortal.EUR,
  },
  [CurrencyCodeEnum.CAD]: {
    code: CurrencyCodeEnum.CAD,
    symbol: CurrencySymbolsPortal.CAD,
  },
  [CurrencyCodeEnum.USD]: {
    code: CurrencyCodeEnum.USD,
    symbol: CurrencySymbolsPortal.USD,
  },
  [CurrencyCodeEnum.CHF]: {
    code: CurrencyCodeEnum.CHF,
    symbol: CurrencySymbolsPortal.CHF,
  },
  [CurrencyCodeEnum.CZK]: {
    code: CurrencyCodeEnum.CZK,
    symbol: CurrencySymbolsPortal.CZK,
    position: "after",
  },
  [CurrencyCodeEnum.GBP]: {
    code: CurrencyCodeEnum.GBP,
    symbol: CurrencySymbolsPortal.GBP,
  },
  [CurrencyCodeEnum.JPY]: {
    code: CurrencyCodeEnum.JPY,
    symbol: CurrencySymbolsPortal.JPY,
  },
  [CurrencyCodeEnum.MXN]: {
    code: CurrencyCodeEnum.USD,
    symbol: CurrencySymbolsPortal.USD,
  },
  [CurrencyCodeEnum.SEK]: {
    code: CurrencyCodeEnum.SEK,
    symbol: CurrencySymbolsPortal.SEK,
  },
  [CurrencyCodeEnum.NOK]: {
    code: CurrencyCodeEnum.NOK,
    symbol: CurrencySymbolsPortal.NOK,
  },
  [CurrencyCodeEnum.NZD]: {
    code: CurrencyCodeEnum.NZD,
    symbol: CurrencySymbolsPortal.NZD,
  },
  [CurrencyCodeEnum.PLN]: {
    code: CurrencyCodeEnum.PLN,
    symbol: CurrencySymbolsPortal.PLN,
    position: "after",
  },
  [CurrencyCodeEnum.SGD]: {
    code: CurrencyCodeEnum.SGD,
    symbol: CurrencySymbolsPortal.SGD,
  },
  [CurrencyCodeEnum.TRY]: {
    code: CurrencyCodeEnum.TRY,
    symbol: CurrencySymbolsPortal.TRY,
  },
  [CurrencyCodeEnum.HKD]: {
    code: CurrencyCodeEnum.HKD,
    symbol: CurrencySymbolsPortal.HKD,
  },
};
